export enum GymRight {
    ManageSubscriptions = 'ManageSubscriptions',
    AlterGymInformation = 'AlterGymInformation',
    ManageGymRights = 'ManageGymRights',
    ManageMemberships = 'ManageMemberships',
    ManageMembers = 'ManageMembers',
    ManageLocationRights = 'ManageLocationRights',
    ManageLocationAreas = 'ManageLocationAreas',
}
